import { createSelector } from '@reduxjs/toolkit'
import { State } from '../types'
import { TaxCouponState } from './TaxCouponTypes'

const selectFeature = (state: State) => state.taxCoupon

export const selectEntryDataIsComplete = createSelector(
  selectFeature,
  (state: TaxCouponState) => !!(state.taxCoupon
    && state.couponDate
    && state.userBadge
    && state.dock),
)

export const selectItems = createSelector(
  selectFeature,
  (state: TaxCouponState) => state.items,
)

export const selectBarcodeAttempted = createSelector(
  selectFeature,
  (state: TaxCouponState) => state.barcodeAttempted,
)

export const selectBarcodeData = createSelector(
  selectFeature,
  (state: TaxCouponState) => ({
    idModel: state.scannedIdModelo,
    description: state.scannedDescription,
  }),
)

export const selectShouldOpenSearchModal = createSelector(
  selectFeature,
  (state: TaxCouponState) => state.shouldOpenSearchModal,
)

export const selectTaxCouponData = createSelector(
  selectFeature,
  (state: TaxCouponState) => ({
    taxCoupon: state.taxCoupon,
    couponDate: state.couponDate,
    userBadge: state.userBadge,
    dock: state.dock,
    idReceivement: state.idReceivement,
    items: state.items.map((item) => ({
      idModel: item.idModel,
      barcode: item.barcode,
      boxQuantity: item.boxQuantity,
      measureUnit: item.idMeasure,
      quantity: item.quantity,
      single: item.single,
      unitCost: item.unitCost,
      expirationDate: item.expirationDate,
      idBatch: item.idBatch,
    })),
  }),
)

export const selectBatchInfo = createSelector(
  selectFeature,
  (state: TaxCouponState) => ({
    taxCoupon: state.taxCoupon,
    couponDate: state.couponDate,
    userBadge: state.userBadge,
    dock: state.dock,
    items: state.items.map((item) => ({
      idModelo: item.idModel,
      barcode: item.barcode,
      boxQuantity: item.boxQuantity,
      idMeasure: item.idMeasure,
      quantity: item.quantity,
      single: item.single,
      unitCost: item.unitCost,
      expirationDate: item.expirationDate,
    })),
  }),
)

export const selectIdReceivement = createSelector(
  selectFeature,
  (state: TaxCouponState) => state.idReceivement,
)

export const selectBatchesDirectGondola = createSelector(
  selectFeature,
  (state: TaxCouponState) => ({
    batchesDirectGondola: state.batchesDirectGondola,
    directGondolaPrintLimit: state.directGondolaPrintLimit,
  }),
)

export const selectReceivementUnitChange = createSelector(
  selectFeature,
  (state: TaxCouponState) => state.receivementUnitChange,
)

export default selectFeature
